import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { injectIntl, defineMessages } from 'react-intl';
import { getFormValues, isValid, reset } from 'redux-form';

import { Segment, Grid, Button, Image } from 'semantic-ui-react';
import { Map } from 'immutable';
import { ModalEduAdd } from 'components';

import * as common from 'libs/commonFunc';
import * as eduActions from 'modules/edu';
import * as currentStatusActions from 'modules/currentStatus';

let licenseResult = null;
class CtStartEdu extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      isClicked: false,
      isError: false,
      openAddModal: false
    };
  }

  componentDidUpdate(prevProps) {
    const { EduActions, openAddModal } = this.props;
    if (prevProps.openAddModal !== openAddModal) {
      EduActions.changeEdu({ name: 'eduVideoQuizInfo', value: [] });
    }
  }

  getEduInfo = async () => {
    this.setState({ isLoading: true });

    try {
      const { EduActions } = this.props;
      await EduActions.getEduExam();
      await EduActions.getEduTag();
      await EduActions.getEduAttach();
    } catch (e) {
      console.log(e)
    }

    this.setState({ isLoading: false });
  }

  // 성공 실패시 알림창
  onToggleSnackbar = message => {
    const { CurrentStatusActions } = this.props;
    setTimeout(() => {
      CurrentStatusActions.toggleSnackbar({ message: '' });
    }, 5000);

    CurrentStatusActions.toggleSnackbar({ message });
  };

  // 모달 처리
  // onToggleModal = viewType => {
  //   // (태그 추가 모달) 초기화
  //   const { ReduxFormReset, CurrentStatusActions } = this.props;
  //   ReduxFormReset('formEduPost');

  //   CurrentStatusActions.onToggleModal({ viewType: viewType });

  //   // 에러 초기화
  //   this.initEduLicense();
  // };

  // 교육 실시 모달
  // onEduToggleModal = modalType => {
  //   const { CurrentStatusActions } = this.props;

  //   this.onToggleModal(modalType);
  // };

  onEduToggleModal = () => {
    const { openAddModal } = this.state;
    const { ReduxFormReset } = this.props;
    ReduxFormReset('formEduPost');

    this.setState({
      openAddModal: !openAddModal
    });

    // 에러 초기화
    this.initEduLicense();
  };

  // 교육 동영상별 퀴즈 리스트 조회
  onGetVideoQuiz = async () => {
    try {
      this.setState({ isLoading: true });
      const { EduActions, formStore } = this.props;
      const params = {
        eduAttachNo: formStore.values.eduAttachNo
      };
      await EduActions.getEduModalQuiz(params);
    } catch (e) {
      console.log(e);
    }

    this.setState({ isLoading: false });
  };

  // 교육 실시(등록)
  onPostEdu = async () => {
    if (!!this.state.isClicked) {
      return false;
    }

    this.setState({
      // isLoading: true,
      isClicked: true
    });

    try {
      const { EduActions, formEduPost, formStore, formEduPostIsValid, eduVideoQuizInfo } = this.props;

      if (!!formEduPost && !!formEduPostIsValid) {
        const isSubmit = false;
        const params = {
          eduAttachNo: '',
          eduName: '',
          startEpoch: '',
          endEpoch: '',
          tagNoArray: [],
          examNoArray: []
        };

        params.eduAttachNo = formEduPost.eduAttachNo;
        params.eduName = formEduPost.eduName;
        params.startEpoch = common.epochFromDate(formEduPost.startEpoch);
        params.endEpoch = common.epochFromDate(formEduPost.endEpoch);
        params.tagNoArray = formEduPost.tagNoArray;
        params.examNoArray = formEduPost.examNoArray;

        // 영상별로 선택한 퀴즈 번호들을 하나의 배열에 저장
        const quizNoArray = [];
        eduVideoQuizInfo.map(value => {
          const item = 'quizNoArray' + value.fileNo.toString();
          formEduPost[item] && formEduPost[item].map(quizNo => {
            quizNoArray.push(quizNo);
          });
        });
        if (quizNoArray.length > 0) {
          params.quizNoArray = JSON.stringify(quizNoArray);
        }

        const respObj = await EduActions.postEdu(params);
        if (respObj && respObj.status && respObj.status === 200 && respObj.data) {
          // 교육 실시 후 교육 정보 조회(새로고침)
          this.onEduRefresh();

          licenseResult = respObj.data;

          if (respObj.data.isValidLicense === 0) {
            this.setState({ isError: true });
          } else {
            this.onEduToggleModal('');
          }
        } else {
          console.log('교육 실패');
        }
      } else {
        window.markFieldValidate(formStore, 'formEduPost');
      }
      this.setState({ isClicked: false });
    } catch (e) {
      console.log(e);
    }
  };

  // 새로 고침
  onEduRefresh = () => {
    const { EduActions } = this.props;
    EduActions.getEdu();

    // 필터 초기화
    EduActions.changeEduTargetParam({
      name: 'filter',
      value: Map({})
    });
  };

  // 교육 실시 라이센스 정보 초기화
  initEduLicense = () => {
    licenseResult = null;

    this.setState({
      isClicked: false,
      isError: false
    });
  };

  // 교육 수정 모달 - 훈련 선택 dropdown
  handleChangeExam = (e, value) => {
    const { CurrentStatusActions } = this.props;

    CurrentStatusActions.changeEduExam({
      selectEduExamNoArray: value
    });
  };

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const {
      openAddModal,
      isClicked,
      isLoading,
      isError
    } = this.state;
    const {
      formStore,
      eduExamOrdering,
      eduExamByExamNo,
      eduAttachOrdering,
      eduAttachByAttachNo,
      eduTagOrdering,
      eduTagByTagNo,
      eduVideoQuizInfo
    } = this.props;
    const {
      onPostEdu,
      onGetVideoQuiz,
      initEduLicense,
      onEduToggleModal,
      handleChangeExam,
      getEduInfo
    } = this;

    return (
      <div className="bt-education-area">
        {openAddModal &&
          <ModalEduAdd
            visible
            onPostEdu={onPostEdu}
            onToggleModal={onEduToggleModal}
            initEduLicense={initEduLicense}
            eduExamByExamNo={eduExamByExamNo}
            eduExamOrdering={eduExamOrdering}
            eduAttachOrdering={eduAttachOrdering}
            eduAttachByAttachNo={eduAttachByAttachNo}
            eduTagOrdering={eduTagOrdering}
            eduTagByTagNo={eduTagByTagNo}
            tagData={eduTagByTagNo.toJS()}
            isLoading={isLoading}
            isClicked={isClicked}
            licenseResult={licenseResult}
            isError={isError}
            formStore={formStore}
            handleChangeExam={handleChangeExam}
            onGetVideoQuiz={onGetVideoQuiz}
            eduVideoQuizInfo={eduVideoQuizInfo}
            getEduInfo={getEduInfo}
          />}

        <Button className={'bt-startEdu'} onClick={onEduToggleModal}>
          {defineMessages(formatMessage({ id: 'EduAdd_1', defaultMessage: '교육 실시' }))}
        </Button>
      </div>

    )
  }
}


const mapStateToProps = state => ({
  tagData: state.edu.get('tagDataByTagNo'),
  isModal: state.currentStatus.get('isModal'),
  // 훈련 리스트
  eduExamOrdering: state.edu.get('eduExamOrdering'),
  eduExamByExamNo: state.edu.get('eduExamByExamNo'),
  // 대상자
  eduTargetDataByTargetNo: state.edu.get('eduTargetDataByTargetNo'),
  // 교육
  eduSummaryByEduNo: state.edu.get('eduSummaryByEduNo'),
  // 컨텐츠 리스트
  eduAttachOrdering: state.edu.get('eduAttachOrdering'),
  eduAttachByAttachNo: state.edu.get('eduAttachByAttachNo'),
  // 태그 리스트
  eduTagOrdering: state.edu.get('eduTagOrdering'),
  eduTagByTagNo: state.edu.get('eduTagByTagNo'),
  // 퀴즈 리스트
  eduVideoQuizInfo: state.edu.get('eduVideoQuizInfo'),
  // 선택 된 교육 번호
  selectEduNo: state.currentStatus.getIn(['edu', 'selectEduNo']),
  totalEdu: state.edu.get('totalEdu'),
  formStore: state.form['formEduPost'],
  formEduPost: getFormValues('formEduPost')(state),
  formEduPostIsValid: isValid('formEduPost')(state)
});

const mapDispatchToProps = dispatch => ({
  EduActions: bindActionCreators(eduActions, dispatch),
  CurrentStatusActions: bindActionCreators(currentStatusActions, dispatch),
  ReduxFormReset: bindActionCreators(reset, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(CtStartEdu));


// WEBPACK FOOTER //
// ./src/script/containers/edu/CtStartEdu.js